import React from 'react';
import { Link } from 'react-router-dom';
import ImageProcessor from './ImageProcessor';
import './Homework1.css';

const Homework1: React.FC = () => {
  return (
    <div className="homework-page">
      <div className="homework-header animate-fade-in-up">
        <div className="header-background">
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>

        <div className="header-content">
          <div className="nav-section">
            <Link to="/" className="back-button">
              <span className="back-icon">←</span>
              <span>Back to Hub</span>
            </Link>
          </div>

          <div className="hero-content">
            <div className="hw-badge">
              <span className="badge-text">Assignment 1</span>
            </div>

            <div className="hw-title">
              <h1>Block-Based Image Averaging</h1>
              <div className="title-decoration"></div>
            </div>

            <div className="hw-description">
              <p>
                Transform your images with sophisticated block averaging algorithms.
                Upload any image and customize block dimensions to create stunning pixelated effects
                with precise mathematical control.
              </p>

              <div className="feature-highlights">
                <div className="highlight">
                  <div className="highlight-icon">🎯</div>
                  <span>Custom Block Sizing</span>
                </div>
                <div className="highlight">
                  <div className="highlight-icon">⚡</div>
                  <span>Real-time Processing</span>
                </div>
                <div className="highlight">
                  <div className="highlight-icon">📊</div>
                  <span>Histogram Analysis</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="homework-content animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
        <ImageProcessor />
      </div>
    </div>
  );
};

export default Homework1;